module.exports = __webpack_public_path__ + "static/media/cross-join-icon.27e9ddea.svg";